import React from 'react';

export const pageMeta = {
  "name": "Web Storage API",
  "link": "/javascript/web-api/storage"
};

export default function JavascriptWebApiStorage() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Web Storage API</h2>
      <p>Route: /javascript/web-api/storage</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
